import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGooglemybusiness = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2491 4.72778H1.3583C1.05201 4.72778 0.803711 4.97608 0.803711 5.28237V14.6415C0.803711 14.9478 1.05201 15.1961 1.3583 15.1961H14.2491C14.5554 15.1961 14.8037 14.9478 14.8037 14.6415V5.28237C14.8037 4.97608 14.5554 4.72778 14.2491 4.72778Z",
			fill: "#4989F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0873 4.64911H1.50461C1.11483 4.64911 0.811523 7.66565 0.811523 8.05542L7.7022 15.196H14.0873C14.4783 15.195 14.795 14.8783 14.796 14.4873V5.35768C14.7949 4.96676 14.4782 4.65018 14.0873 4.64911Z",
			fill: "url(#paint0_linear_74_26551)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.00049 6.48085H8.00049V1.23093H4.59944L4.00049 6.48085Z",
			fill: "#3C4BA6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0005 6.48085H8.00049V1.23093H11.4015L12.0005 6.48085ZM14.8038 2.22611L14.8088 2.24401C14.8076 2.23769 14.8051 2.23183 14.8038 2.22611Z",
			fill: "#7BABF7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.8086 2.24386L14.8036 2.22596C14.6768 1.64526 14.1628 1.23115 13.5684 1.23077H11.4014L11.9999 6.48085H15.9999L14.8086 2.24386Z",
			fill: "#3F51B5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.19773 2.2261L1.19238 2.24539C1.19368 2.23858 1.19627 2.23226 1.19773 2.2261Z",
			fill: "#7BABF7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.19203 2.24386L1.19699 2.22596C1.3238 1.64526 1.83779 1.23115 2.43218 1.23077H4.5994L4 6.48085H0L1.19203 2.24386Z",
			fill: "#7BABF7"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.00702 6.47949C4.00702 7.58343 3.11209 8.47836 2.00815 8.47836C0.904209 8.47836 0.00927734 7.58343 0.00927734 6.47949H4.00702Z",
			fill: "#709BE0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.00507 6.47949C8.00507 7.58343 7.11014 8.47836 6.0062 8.47836C4.90226 8.47836 4.00732 7.58343 4.00732 6.47949H8.00507Z",
			fill: "#3C4BA6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.0026 6.47949C12.0026 7.58343 11.1077 8.47836 10.0038 8.47836C8.89981 8.47836 8.00488 7.58343 8.00488 6.47949H12.0026Z",
			fill: "#709BE0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.0002 6.47949C16.0002 7.58343 15.1053 8.47836 14.0013 8.47836C12.8974 8.47836 12.0024 7.58343 12.0024 6.47949H16.0002Z",
			fill: "#3C4BA6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.001 11.895C13.9939 11.7998 13.9822 11.7129 13.9655 11.6019H11.785C11.785 11.9069 11.785 12.2396 11.7838 12.5448H13.047C13.0202 12.6869 12.9655 12.8224 12.8861 12.9434C12.8068 13.0645 12.7043 13.1686 12.5846 13.2499C12.5846 13.2499 12.5846 13.2446 12.5837 13.2445C12.4291 13.346 12.2549 13.4139 12.0724 13.444C11.8894 13.4775 11.7018 13.4767 11.5192 13.4416C11.3337 13.4032 11.1581 13.3271 11.0032 13.218C10.7747 13.0559 10.5984 12.8307 10.496 12.5699C10.4882 12.5496 10.481 12.5291 10.4736 12.5084V12.5061L10.4756 12.5046C10.3762 12.2129 10.3759 11.8966 10.4748 11.6048C10.5445 11.4 10.6591 11.2135 10.8103 11.0589C11.165 10.692 11.6949 10.554 12.1835 10.7013C12.3709 10.7588 12.5421 10.8595 12.6832 10.9954L13.1094 10.5693C13.1846 10.4933 13.2626 10.4198 13.335 10.3413C13.1189 10.1397 12.8652 9.98267 12.5885 9.87904C12.0849 9.69642 11.5339 9.69159 11.0271 9.86536C11.0095 9.87137 10.992 9.87764 10.9745 9.88415C10.4278 10.0897 9.97804 10.4928 9.71406 11.0138C9.62085 11.1982 9.55296 11.3944 9.51226 11.5969C9.27087 12.7965 10.0028 13.9773 11.1846 14.2947C11.5709 14.3981 11.9816 14.3956 12.3709 14.3072C12.7246 14.2273 13.0517 14.0573 13.3204 13.8138C13.6007 13.5559 13.8016 13.2123 13.9068 12.8473C13.9949 12.538 14.0267 12.2155 14.001 11.895Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_74_26551",
			x1: .811523,
			y1: 9.92246,
			x2: 14.7959,
			y2: 9.92246,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .03,
				stopColor: "#4079D8"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#4989F5"
			})]
		}) })
	]
});
export default SvgGooglemybusiness;
